import React, { useState } from 'react'
import { Typography } from '@mui/material';
import { TextField, Autocomplete } from '@mui/material';
import { Button, Grid, Link, Stack } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import colors from '../../colors'
import { useSelector, useDispatch } from 'react-redux';
import { selectRegistrationState, decrementCurrentRegistrationStep, setAddress, setBirthdate, setCity, setFullName, setGender, setShouldFacePhiApply } from '../../../features/registration/registrationSlice'
import { selectTermsAndConditionsState } from '../../../features/termsAndConditions/termsAndConditionsSlice'
import { setToken } from '../../../features/global/globalDataSlice'
import FormHelperText from '@mui/material/FormHelperText';
import moment from 'moment';
import { useFormik } from 'formik'
import * as yup from 'yup'
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import { sendGeneralRequest } from '../../../features/generalRequest'
import { LocalizationProvider } from '@mui/lab';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { makeStyles } from '@mui/styles';
import { texts } from '../../general/texts';
import { selectLoginState } from '../../../features/login/loginSlice';
import CountrySelect from '../../general/uanataca/CountrySelect';

const FifthRegistrationStep = () => {
    const registrationSliceState = useSelector(selectRegistrationState)
    const loginSlice = useSelector(selectLoginState)
    const termsAndConditionsSliceState = useSelector(selectTermsAndConditionsState)
    const [countryID, setCountryID] = useState('AL');
    const [residence, setResidence] = useState('AL');
    const dispatch = useDispatch()

    const albanianCities = [
        "Berat",
        "Dibër",
        "Durrës",
        "Elbasan",
        "Fier",
        "Gjirokastër",
        "Korçë",
        "Kukës",
        "Lezhë",
        "Shkodër",
        "Tiranë",
        "Vlorë",
    ];

    const validationSchema = yup.object({
        ...(loginSlice.isManualRegistration) ? {
            fullName: yup
                .string(texts["message-invalid-full-name"])
                .matches(/[a-zA-ZçëÇË]+\s[a-zA-ZçëÇË]+\s[a-zA-ZçëÇË]+/, {
                    message: "Formati i sakte eshte: Emër Atësi Mbiemër",
                })
                .required(texts["message-invalid-full-name"]),
        } : {
            fullName: yup
                .string(texts["message-invalid-full-name"])
                .matches(/[a-zA-ZçëÇË]+\s[a-zA-ZçëÇË]+/, {
                    message: "Formati i sakte eshte: Emër Mbiemër",
                })
                .required(texts["message-invalid-full-name"]),
        },
        city: yup
            .string(texts["message-invalid-city"])
            .min(3, "City must be at least 3 characters")
            .required(texts["message-invalid-city"]),
        address: yup
            .string(texts["message-invalid-address"])
            .required(texts["message-invalid-address"]),
        ...(registrationSliceState.accountType === 2) &&
        {
            businessName: yup
                .string(texts["message-invalid-business-name"])
                .required(texts["message-invalid-business-name"]),
        },
        birthDate: yup
            .string(texts["message-invalid-birthdate"])
            // .matches(/^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/,{
            //     message:'Datelindja duhet te jete ne formatin DD/MM/YYYY'
            // })
            .required(texts["message-invalid-birthdate"])
            .nullable(),
        gender: yup
            .string(texts["message-invalid-gender"])
            .required(texts["message-invalid-gender"]),
        idTC: yup
            .bool()
            .oneOf([true], texts["message-invalid-terms-and-conditions"]),
        ...(registrationSliceState.accountType === 1) &&
        {
            pep: yup
                .string(texts["message-fill-field"])
                .required(texts["message-fill-field"]),
            income: yup
                .string(texts["message-fill-field"])
                .required(texts["message-fill-field"]),
        },
        ...(registrationSliceState.accountType === 1 && !loginSlice.isManualRegistration) &&
        {
            fathersName: yup
                .string(texts["message-fill-field"])
                .required(texts["message-fill-field"]),
        },
        ...(registrationSliceState.accountType === 1 && countryID !== 'AL') &&
        {
            taxNumber: yup
                .string(texts["message-fill-field"])
                .required(texts["message-fill-field"]),
            secondaryAddress: yup
                .string(texts["message-fill-field"])
                .required(texts["message-fill-field"]),
        }
    });

    const handleCountryChange = (selectedCountry) => {
        setCountryID(selectedCountry.shortCode)
    }

    const handleResidence = (val) => {
        setResidence(val.shortCode)
    }

    const removePrefix = (base64String) => {
        if (base64String.startsWith('data:image/jpeg;base64,')) {
            return base64String.slice('data:image/jpeg;base64,'.length);
        }
        return base64String;
    };

    const modifiedBase64 = removePrefix(registrationSliceState.idPictureBase64);
    const formik = useFormik({
        initialValues: {
            token: loginSlice.loginWhenFacephiDone ? loginSlice.token : registrationSliceState.token,
            fullName: '',
            city: '',
            address: '',
            birthDate: '',
            gender: '',
            businessName: '',
            idTC: false,
            idPrivacyPolicy: '',
            ext: registrationSliceState.idPictureExtension,
            base64Content: modifiedBase64,
            idNumber: registrationSliceState.idNumber,
            expiryDate: registrationSliceState.idExpiryDate,
            accountType: registrationSliceState.accountType,
            pep: '',
            income: '',
            fathersName: '',
            secondaryAddress: '',
            taxNumber: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            var splitFullName = ""
            if (!loginSlice.isManualRegistration) {
                var temp = values.fullName.split(' ');
                var firstName = temp[0]
                var lastName = temp.slice(1).join(' ')
                values.fullName = firstName + " " + lastName
            }
            splitFullName = values.fullName.split(/(\s+)/);
            dispatch(setToken(registrationSliceState.token))
            dispatch(sendGeneralRequest({
                request: {
                    _request: {
                        ...values,
                        expiryDate: loginSlice.isManualRegistration ? moment(values.expiryDate).format('DD/MM/yyyy') : values.expiryDate,
                        idTC: termsAndConditionsSliceState.idTC,
                        idPrivacyPolicy: termsAndConditionsSliceState.idPrivacyPolicy,
                        isFacephi: registrationSliceState.docNumber !== '' ? true : false,
                        nationality: countryID,
                        residence: residence,
                        isPep: values.pep === '0',
                        documentNumber: registrationSliceState.docNumber,
                        birthDate: loginSlice.clientData?.birthDate ? values.birthDate : moment(values.birthDate).format('DD/MM/yyyy'),
                        name: splitFullName[0].charAt(0).toUpperCase() + splitFullName[0].slice(1),
                        fathersName: (!loginSlice.isManualRegistration && registrationSliceState.accountType === 1) ?
                            values.fathersName :
                            splitFullName[2].charAt(0).toUpperCase() + splitFullName[2].slice(1),
                        surname: (!loginSlice.isManualRegistration && registrationSliceState.accountType === 1) ?
                            splitFullName[2].charAt(0).toUpperCase() + splitFullName[2].slice(1) :
                            splitFullName[4].charAt(0).toUpperCase() + splitFullName[4].slice(1)
                    }
                }, baseUrlKey: 'auth', endpoint: 'UpdateUserDataNew'
            }))
        }
    })

    const onBackButtonClick = () => {
        dispatch(setFullName(formik.values.fullName))
        dispatch(setAddress(formik.values.address))
        dispatch(setCity(formik.values.city))
        dispatch(setBirthdate(formik.values.birthDate))
        dispatch(setGender(formik.values.gender))
        dispatch(decrementCurrentRegistrationStep())
    }

    const parseDate = (input) => {
        const parsedDate = moment(input, 'DD/MM/yyyy');
        const formattedDate = parsedDate.format('MM/DD/YYYY');
        return formattedDate
    }

    React.useEffect(() => {
        dispatch(sendGeneralRequest({ request: { _request: { TypeOfAccount: registrationSliceState.accountType } }, baseUrlKey: 'auth', endpoint: 'GetTermsAndConditions' }))
    }, [])

    React.useEffect(() => {
        formik.setFieldValue('fullName', registrationSliceState.fullName)
        formik.setFieldValue('address', registrationSliceState.address)
        formik.setFieldValue('city', registrationSliceState.city)
        formik.setFieldValue('birthDate', registrationSliceState.birthDate)
        formik.setFieldValue('gender', registrationSliceState.gender)
    }, [registrationSliceState.fullName, registrationSliceState.address, registrationSliceState.city, registrationSliceState.birthDate, registrationSliceState.gender])

    const useStyles = makeStyles({
        mainGrid: {
            width: '60%',
            '@media (min-width: 899px)': { marginLeft: '15%' },
            '@media (max-width: 1440px)': { width: '70%' },
            '@media (max-width: 1024px)': { width: '85%' },
            '@media (max-width: 768px)': { width: '80%' },
            '@media (max-width: 425px)': { width: '90%' }
        },
        fieldTitle: {
            color: colors.orange,
            fontSize: '1.2rem',
            fontFamily: 'GerberaMedium'
        },
        textField: {
            width: '15vw',
            '@media (max-width: 899px)': { width: '70vw' }
        },
        button: {
            background: colors.gradientOrange,
            color: colors.white,
            width: '12%',
            fontFamily: 'GerberaBold',
            textTransform: 'none',
            fontSize: '1rem',
            '@media (max-width: 899px)': { width: '40%' }
        },
        link: {
            fontFamily: 'GerberaLight',
            color: colors.orange,
            textDecorationColor: colors.orange,
            "&:hover": { textDecorationColor: '#FF8403', color: '#FF8403' }
        }
    })

    const classes = useStyles()

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container justifyContent='center' width={'100%'}>
                <Grid container className={classes.mainGrid} >
                    <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-full-name"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="fullName" name="fullName" onChange={formik.handleChange} value={formik.values.fullName} error={formik.touched.fullName && Boolean(formik.errors.fullName)} helperText={formik.touched.fullName && formik.errors.fullName} color={'warning'} label={texts["placeholder-full-name"]} variant="standard" disabled={!loginSlice.isManualRegistration} className={classes.textField} /></Grid>
                    </Grid>
                    {!loginSlice.isManualRegistration && registrationSliceState.accountType === 1 && (
                        <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                            <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["placeholder-father-name"]}</Typography></Grid>
                            <Grid container item justifyContent='flex-start'><TextField id="fathersName" name="fathersName" onChange={formik.handleChange} value={formik.values.fathersName}
                                error={formik.touched.fathersName && Boolean(formik.errors.fathersName)} helperText={formik.touched.fathersName && formik.errors.fathersName}
                                color={'warning'} variant="standard" className={classes.textField}
                            /></Grid>
                        </Grid>
                    )}
                    {registrationSliceState.accountType === 1 && (
                        <Grid item md={6} xs={12} mb={8} >
                            <Grid container item justifyContent='flex-start' mb={2}>
                                <Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-residence"]}</Typography>
                            </Grid>
                            <CountrySelect onCountryChange={handleResidence} isNotDisabled={true} />
                        </Grid>
                    )}
                    {(registrationSliceState.accountType === 1 && residence !== 'AL') ? (
                        <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                            <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-city"]}</Typography></Grid>
                            <Grid container item justifyContent='flex-start'><TextField id="city" name="city" onChange={formik.handleChange} value={formik.values.city} error={formik.touched.city && Boolean(formik.errors.city)} helperText={formik.touched.city && formik.errors.city} color={'warning'} variant="standard" className={classes.textField} /></Grid>
                        </Grid>) :
                        (
                            <Grid container item md={6} xs={12} mb={8} flexDirection="column">
                                <Grid container item justifyContent="flex-start" mb={2}>
                                    <Typography className={classes.fieldTitle} variant="h6">
                                        {texts["title-registration-city"]}
                                    </Typography>
                                </Grid>
                                <Autocomplete
                                    sx={{ width: '200px' }}
                                    id="city"
                                    options={albanianCities}
                                    value={formik.values.city || ""}
                                    onChange={(event, newValue) => {
                                        formik.setFieldValue("city", newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            color='warning'
                                            label={texts["title-registration-city"]}
                                            error={formik.touched.city && Boolean(formik.errors.city)}
                                            helperText={formik.touched.city && formik.errors.city}
                                            className={classes.textField}
                                        />
                                    )}
                                />
                            </Grid>
                        )}

                    <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-address"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="address" name="address" onChange={formik.handleChange} value={formik.values.address} label={texts["street/building/apartment"]} error={formik.touched.address && Boolean(formik.errors.address)} helperText={formik.touched.address && formik.errors.address} color={'warning'} variant="standard" className={classes.textField} /></Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-birthdate"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'>
                            {/* <TextField id="birthDate" name="birthDate" onChange={formik.handleChange} value={formik.values.birthDate} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} helperText={formik.touched.birthDate && formik.errors.birthDate} color={'warning'} placeholder='DD/MM/YYYY' variant="standard" sx={{width:'60%'}} /> */}
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Stack spacing={3}>
                                    {!registrationSliceState.shouldFacePhiApply ? (
                                        <DesktopDatePicker
                                            inputFormat="dd/MM/yyyy"
                                            openTo="day"
                                            views={['day', 'month', 'year']}
                                            value={formik.values.birthDate}
                                            id='birthDate' name='birthDate' onChange={val => { formik.setFieldValue("birthDate", val); }} color={'warning'}
                                            renderInput={(params) =>
                                                <TextField variant="standard" id='birthDate' name='birthDate' label='dd/mm/yyyy' color={'warning'} helperText={formik.touched.birthDate && formik.errors.birthDate} className={classes.textField} {...params} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} />}
                                        />) :
                                        <DesktopDatePicker
                                            inputFormat="dd/MM/yyyy"
                                            openTo="day"
                                            views={['day', 'month', 'year']}
                                            value={parseDate(formik.values.birthDate)}
                                            disabled
                                            id='birthDate' name='birthDate' onChange={val => { formik.setFieldValue("birthDate", val); }} color={'warning'}
                                            renderInput={(params) =>
                                                <TextField variant="standard" id='birthDate' name='birthDate' label='dd/mm/yyyy' color={'warning'} helperText={formik.touched.birthDate && formik.errors.birthDate} className={classes.textField} {...params} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} />}
                                        />}
                                </Stack>
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    {registrationSliceState.accountType === 1 && (
                        <Grid item md={6} xs={12} mb={8} >
                            <Grid container item justifyContent='flex-start' mb={2}>
                                <Typography className={classes.fieldTitle} variant="h6">{texts["nationality"]}</Typography>
                            </Grid>
                            <CountrySelect onCountryChange={handleCountryChange} />
                        </Grid>
                    )}
                    {registrationSliceState.accountType === 1 && (
                        <Grid item md={6} xs={12} mb={8}>
                            <Grid container item justifyContent='flex-start' mb={2}>
                                <Typography className={classes.fieldTitle} variant="h6">PEP <span style={{ fontSize: '12px' }}>(Person i ekspozuar politikisht)</span></Typography>
                            </Grid>
                            <Grid container item justifyContent='flex-start'>
                                <RadioGroup name="pep" row aria-labelledby="demo-row-radio-buttons-group-label" value={formik.values.pep} onChange={formik.handleChange} >
                                    <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value={'Po'} control={<Radio color='warning' value={0} />} label={texts["yes"]} />
                                    <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value={'Jo'} control={<Radio color='warning' value={1} />} label={texts["no"]} />
                                </RadioGroup>
                            </Grid>
                            {formik.touched.pep && <FormHelperText error>{formik.errors.pep}</FormHelperText>}
                        </Grid>
                    )}
                    {registrationSliceState.accountType === 1 && (countryID !== 'AL') && (
                        <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                            <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["secondary-address"]}</Typography></Grid>
                            <Grid container item justifyContent='flex-start'><TextField id="secondaryAddress" name="secondaryAddress" label={texts["street/building/apartment"]} onChange={formik.handleChange} value={formik.values.secondaryAddress} error={formik.touched.secondaryAddress && Boolean(formik.errors.secondaryAddress)} helperText={formik.touched.secondaryAddress && formik.errors.secondaryAddress} color={'warning'} variant="standard" className={classes.textField}
                            /></Grid>
                        </Grid>
                    )}
                    {registrationSliceState.accountType === 1 && (countryID !== 'AL') && (
                        <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                            <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["tax-number"]}</Typography></Grid>
                            <Grid container item justifyContent='flex-start'><TextField id="taxNumber" name="taxNumber" onChange={formik.handleChange} value={formik.values.taxNumber} error={formik.touched.taxNumber && Boolean(formik.errors.taxNumber)} helperText={formik.touched.taxNumber && formik.errors.taxNumber} color={'warning'} variant="standard" className={classes.textField}
                            /></Grid>
                        </Grid>
                    )}
                    {registrationSliceState.accountType === 1 && (
                        <Grid container item md={6} xs={12} mb={8} flexDirection='column'>
                            <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["income"]}</Typography></Grid>
                            <Grid container item justifyContent='flex-start'><TextField id="income" name="income" onChange={formik.handleChange} value={formik.values.income} error={formik.touched.income && Boolean(formik.errors.income)} helperText={formik.touched.income && formik.errors.income} color={'warning'} variant="standard" className={classes.textField} /></Grid>
                        </Grid>
                    )}
                    <Grid item md={6} xs={12}>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-gender"]}</Typography>
                        </Grid>
                        <Grid container item justifyContent='flex-start'>
                            <RadioGroup name="gender" row aria-labelledby="demo-row-radio-buttons-group-label" value={formik.values.gender} onChange={formik.handleChange}>
                                <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value={!loginSlice.isManualRegistration ? 'M' : 'Mashkull'} control={<Radio color='warning' value={0} checked={(!loginSlice.isManualRegistration && registrationSliceState.gender === 'M' || registrationSliceState.gender === '0') || (loginSlice.isManualRegistration && formik.values.gender === '0')} />} label={texts["gender-male"]} />
                                <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value={!loginSlice.isManualRegistration ? 'F' : 'Femër'} control={<Radio color='warning' value={1} checked={(!loginSlice.isManualRegistration && registrationSliceState.gender === 'F' || registrationSliceState.gender === '1') || (loginSlice.isManualRegistration && formik.values.gender === '1')} />} label={texts["gender-female"]} />
                            </RadioGroup>
                        </Grid>
                        {formik.touched.gender && <FormHelperText error>{formik.errors.gender}</FormHelperText>}
                    </Grid>
                    <Grid container item md={6} xs={12} flexDirection={'column'} justifyContent={'flex-end'}>
                        <FormGroup>
                            <FormControlLabel onChange={formik.handleChange} control={<Checkbox id="idTC" name="idTC" checked={formik.values.idTC} sx={{ [`&.${checkboxClasses.checked}`]: { color: colors.orange }, color: colors.gray }} />}
                                label={<Typography textAlign="left" color={colors.gray} fontFamily={'GerberaLight'}>
                                    {texts["terms-and-conditions-confirm"]}
                                    <Link href={termsAndConditionsSliceState.termsAndConditionsUrl} target="_blank" style={{ color: colors.orange, marginRight: 5 }}><br />{texts["terms-and-conditions"]}</Link>
                                    {texts["and-separator"]}
                                    <Link href={termsAndConditionsSliceState.privacyUrl} target="_blank" style={{ color: colors.orange }}><br />{texts["privacy-politics"]}</Link>
                                    {texts["of-ep"]}
                                </Typography>
                                } />
                        </FormGroup>
                        {formik.touched.idTC && <FormHelperText error>{formik.errors.idTC}</FormHelperText>}
                    </Grid>
                </Grid>
                <Grid item md={12} xs={12} pt={'2%'}>
                    <Button disabled={registrationSliceState.isLoading ? true : false} type='submit' className={classes.button}>{texts["button-continue"]}</Button>
                </Grid>
                {!registrationSliceState.shouldFacePhiApply && (
                    <Grid item md={12} xs={12} pt={'0.8%'}>
                        <Link disabled={registrationSliceState.isLoading ? true : false} className={classes.link} onClick={onBackButtonClick} component='button' variant='body2'>{texts["button-back"]}</Link>
                    </Grid>)}
            </Grid>
        </form>
    );
}
export default FifthRegistrationStep